import { Tooltip } from 'primereact/tooltip'
import { useContext, useEffect, useRef } from 'react'
import AppMenuitem from './AppMenuitem'
import { LayoutContext } from './context/layoutcontext'
import { MenuProvider } from './context/menucontext'
import type { Breadcrumb, BreadcrumbItem, MenuProps } from '../../types/types'
import { RdmsMenuContext } from '../menu/context/rdmsMenuContext'
import { Menu } from '../../types/menu'
import {useTranslation} from "react-i18next";

const AppSubMenu = (props: MenuProps) => {
    const { menus } = useContext(RdmsMenuContext)
    const { i18n } = useTranslation();
    const { layoutState, setBreadcrumbs } = useContext(LayoutContext)
    const tooltipRef = useRef<Tooltip | null>(null)

    useEffect(() => {
        if (tooltipRef.current) {
            tooltipRef.current.hide()
            ;(tooltipRef.current as any).updateTargetEvents()
        }
    }, [layoutState.overlaySubmenuActive])

    useEffect(() => {
        generateBreadcrumbs(menus)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [menus, i18n.resolvedLanguage])

    const generateBreadcrumbs = (model: Menu[]) => {
        let breadcrumbs: Breadcrumb[] = []

        const getBreadcrumb = (item: BreadcrumbItem, labels: string[] = []) => {
            const { label, to, items, japanLabel } = item

            label && labels.push(i18n.resolvedLanguage === 'ja' ? japanLabel : label)
            items &&
                items.forEach((_item) => {
                    getBreadcrumb(_item, labels.slice())
                })
            to && breadcrumbs.push({ labels, to  })
        }

        model.forEach((item) => {
            getBreadcrumb(item)
        })

        setBreadcrumbs(breadcrumbs)
    }

    return (
        <MenuProvider>
            <ul className="layout-menu">
                {props.model.map((item, i) => {
                    return !item.seperator ? <AppMenuitem item={item} root={true} index={i} key={item.label} /> : <li className="menu-separator"></li>
                })}
            </ul>
            <Tooltip ref={tooltipRef} target="li:not(.active-menuitem)>.tooltip-target" />
        </MenuProvider>
    )
}

export default AppSubMenu
